export const DEFAULT_ERROR_RETRY_COUNT = 3;

export default async function fetcher(url, options) {
  console.log("fetcher", url, options);
  const res = await fetch(url, {
    credentials: "include",
    ...options,
  });

  if (!res.ok) {
    const body = await res.text();

    let err;

    if (res.status >= 500) {
      err = new ServerError(res.statusText);
    } else if (res.status === 404) {
      err = new NotFoundError(res.statusText);
    } else if (res.status >= 400) {
      err = new ClientError(res.statusText);
    } else {
      err = new Error(res.statusText);
    }

    err.body = body;
    err.status = res.status;

    throw err;
  }

  return res.json();
}
